import { useMemo } from 'react';
import { useGetMemberIndividualResultsQuery } from '../state/api';
import MemberIndividualHistory from './member-individual-history';

interface MemberIndividualTournamentHistoryContainerProps {
  member_id: string | undefined;
}

const MemberIndividualTournamentHistoryContainer = ({ member_id }: MemberIndividualTournamentHistoryContainerProps) => {
  const { data: results = [] } = useGetMemberIndividualResultsQuery(member_id!, {
    skip: member_id === undefined,
  });

  const history = useMemo(
    () =>
      results
        .filter((res) => res.competitionSeries === 'Crazy English Tournament')
        .map((res) => ({
          date: res.date ?? '',
          description: res.venue ?? '',
          position: res.position,
          points: res.points,
        })),
    [results]
  );

  return <MemberIndividualHistory history={history} descriptionLabel="Venue" />;
};

export default MemberIndividualTournamentHistoryContainer;
